module.exports = __webpack_public_path__ + "static/media/icon-supplies-tissues.2ee719fd.svg";